export const loadObjectFromStorage = <T extends Record<string, unknown>>(
    storageKey: string,
    defaultValue: T = {} as T,
): T => {
    const item = localStorage.getItem(storageKey);

    if (item === null) {
        return defaultValue;
    }

    try {
        return JSON.parse(item) as T;
    } catch {
        return defaultValue;
    }
};

export const loadStringFromStorage = (storageKey: string, defaultValue = ""): string =>
    localStorage.getItem(storageKey) ?? defaultValue;

export const saveObjectToLocalStorage = <T extends Record<string, unknown>>(storageKey: string, value: T) => {
    localStorage.setItem(storageKey, JSON.stringify(value));
};

export const saveStringToLocalStorage = (storageKey: string, value: string) => {
    localStorage.setItem(storageKey, value);
};
